import { FC } from 'react';
import { Button, ButtonStyles, Icons } from '@silverfort/sf-components';

interface Props {
    title: string;
    disclaimers: string[];
    onClose: () => void;
}

const PoliciesDashboardsDisclaimers: FC<Props> = ({ title, disclaimers, onClose }) => {
    return (
        <div className="w-[360px]">
            <div className="h-[56px] ps-6 pe-4 flex justify-between items-center border-b border-sf-gray-100">
                <span className="font-sf text-14 font-medium">{title}</span>
                <Button iconLeft={Icons.Cancel} buttonStyle={ButtonStyles.GhostSolid} onClick={onClose} />
            </div>
            <div className="px-6 py-8 flex flex-col gap-5">
                {disclaimers.map((disclaimer) => (
                    <div key={disclaimer} className="flex flex-row gap-1">
                        <div className="min-h-[19px] max-h-[19px] min-w-[19px] max-w-[19px] flex justify-center items-center">
                            <div className="h-[3px] w-[3px] rounded-[3px] bg-sf-gray-800" />
                        </div>
                        <span className="font-sf text-13 leading-[19px] tracking-[0.203px]">{disclaimer}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PoliciesDashboardsDisclaimers;
